import $ from 'jquery'
import Backbone from 'backbone'
import mobile from 'scoreboard/components/mobile'
import constants from 'scoreboard/components/constants'
import TreeHoverExpandContract from 'scoreboard/components/tree-hover-expand-contract'
import _ from 'lodash'
import layoutManager from 'scoreboard/components/layout-manager'
import deviceType from 'scoreboard/components/device-type'

const TwoColumnDetailsForm = Backbone.View.extend({

	initialize: function(options) {
		this.options = options || {}
		this.options.expandTree = _.isNil(this.options.expandTree) ?
			true : this.options.expandTree
		this.leftPanel = this.$('.left-panel')
		this.rightPanel = this.$('.right-panel')
		this.scrollContainer = this.options.getScrollContainer()
		_.bindAll(this, 'adjustLeftPanelScroll')
		this._setupListeners()
		this.resize()
		if (this.options.expandTree) {
			this.setupTreeExpander()
		}
	},

	_setupListeners: function() {
		// Take care of the sizing and positioning (floating) of the left panel
		layoutManager.on('resize', () => this.resize())
		this.scrollContainer.on('scroll', this.adjustLeftPanelScroll)
		if (!_.isNil(this.options.gardener)) {
			this.options.gardener._onceTreeRendered(() => this.setupTreeExpander())
		}
	},

	setupTreeExpander: function() {
		delete this.treeExpander

		// When the left tree is hovered over, expand it if it needs to be expanded in order to show the
		// longer org names.
		this.treeExpander = new TreeHoverExpandContract({
			el: this.leftPanel,
			canExpandTree:  () => !this.panelsStacked(),
			expandConstraint: () => this.scrollContainer.outerWidth() - (2 * constants.STANDARD_MARGIN)
		})

		// When the tree expander is done contracting the tree, we need to call
		// resize to make sure the left panel gets the correct width/positioning/scroll.
		this.treeExpander.on('endContract', () => this.resize())

		// Double check to make sure the left panel is as tall as it should be and
		// scrolled to where it should be
		this.resize()
	},

	// The left panel stays at 100% in height and stays with the viewport as
	// the page scrolls or 'floats'.
	resizeLeftPanel: function() {
		// Nix any potential width assignment left over from expanding/contracting
		this.leftPanel.css('width', 'auto')
		this.adjustLeftPanelScroll()

		// If the left pane should keep it's natural height, make sure it isn't
		// overflowing the page, adjust the scroll and return here.
		if (this.options.autoHeight) {
			var maxHeight = this.scrollContainer.height() - 2*constants.STANDARD_MARGIN
			this.leftPanel.css('max-height', this.panelsStacked() ? '' : maxHeight)
			this.trigger('afterLeftPanelResize')
			return
		}

		// the minimum allowable height of the panel while resizing
		let MIN_HEIGHT = Math.min(
			constants.FLOATING_PANEL_MIN_HEIGHT,
			this.scrollContainer.height() - 2*constants.STANDARD_MARGIN
		)

		if (this.options.isDialog) {
			let dialogBody = this.scrollContainer
			let leftPanelHeight
			if (this.panelsStacked()) {
				leftPanelHeight =  Math.max((dialogBody.height() / 2) - constants.STANDARD_MARGIN*2, MIN_HEIGHT)
				this.leftPanel.css('height',leftPanelHeight)
			} else {
				leftPanelHeight = Math.max(
					dialogBody.height() - constants.STANDARD_MARGIN*2 - this._getBannersHeight(),
					MIN_HEIGHT - this._getBannersHeight())
				this.leftPanel.css('height', leftPanelHeight)
			}

			// Since the left panel is position: fixed, and the right panel(s)
			// can be shorter than it, prevent any weird alighnment issues with
			// other block level elements surrounding the form by giving the
			// relatively positioned .left-column a min height #27808.
			this.$('.left-column').css('min-height', leftPanelHeight)

			this.trigger('afterLeftPanelResize')
			return
		}

		// If we're in the mobile layout, we need to calculate the height a bit differently
		// since the containing wrappers are not oriented the same and there's not a top
		// mobile header.
		if (mobile.isMobileOrientation()) {
			let footerHeight = (this.$('footer:visible').length > 0) ? 52 : 0
			if (this.panelsStacked()) {
				let height = (this.$el.height() / 2) - constants.MOBILE_HEADER_HEIGHT
				this.leftPanel.css('height', Math.max(height - footerHeight - constants.STANDARD_MARGIN*2, MIN_HEIGHT))
			} else {
				let height = this.$el.height() - constants.MOBILE_HEADER_HEIGHT
				this.leftPanel.css('height', Math.max(height - footerHeight - constants.STANDARD_MARGIN*2, MIN_HEIGHT))
			}

			this.trigger('afterLeftPanelResize')
			return
		}

		// When the left panel and right panel are stacked on top of one another,
		// the left panel takes up 50% of the height and there's no floating going on.
		let displayPaneBody = $('.display-pane-body')
		if (this.panelsStacked()) {
			this.leftPanel.css('height', (displayPaneBody.outerHeight()/2) - constants.STANDARD_MARGIN*2)
			this.trigger('afterLeftPanelResize')
			return
		}

		var finalHeight = displayPaneBody.outerHeight() - constants.STANDARD_MARGIN*2
		this.leftPanel.css('height', finalHeight)

		this.trigger('afterLeftPanelResize')
	},

	// Adjust the left panel so that it stays on screen during scroll.
	adjustLeftPanelScroll: function(scroll) {
		layoutManager.toggleTransitions(false)
		// Reset the leftPane's top position. It's going to get assigned to something
		// by the end of this function.
		this.leftPanel.css('top', '')

		// The panels are stacked? No need to adjust the left panel width or top
		// positioning because it's not using a fixed position anymore.
		if (this.panelsStacked()) {
			layoutManager.toggleTransitions(true)
			return
		}

		let scrollContainerTop = this.scrollContainer.scrollTop()
		if (this.options.isDialog) {

			var bannersHeight = this._getBannersHeight()
			if (scrollContainerTop <= bannersHeight) {
				// The banners are partially out of the way, so adjust the leftPanel
				// top accordingly.
				let diff = bannersHeight - scrollContainerTop
				this.leftPanel.css('top',
					this.$('.dialog-header').outerHeight()
					+ constants.STANDARD_MARGIN
					+ diff)
			} else if (scrollContainerTop > 0) {
				this.leftPanel.css('top',
					this.$('.dialog-header').outerHeight()
					+ constants.STANDARD_MARGIN)
			}

			// If there is content under this component (like in #27808), we need
			// to make sure that, once we're done scrolling the right panel(s),
			// we also move the left panel up and out of the way so that the content
			// under this component can scroll into view.
			let containerHeight = this.$('.two-column-details-form').height()
			let leftPanelHeight = this.leftPanel.height()
			if (containerHeight <= scrollContainerTop + leftPanelHeight + bannersHeight) {
				this.leftPanel.addClass('is-frozen')
					.css('top', containerHeight - leftPanelHeight - 2 - bannersHeight) // 2px border adjustment
			} else {
				this.leftPanel.removeClass('is-frozen')
			}
		} else {
			let topMarginAdjustment =
				layoutManager.loggedInAsBanner.hasClass('is-selected') ?
				constants.LOGGED_IN_AS_BANNER_HEIGHT + constants.STANDARD_MARGIN :
				constants.STANDARD_MARGIN

			if (mobile.isMobileHeight() && !mobile.isMobileWidth()) {
				// Since in the virtical mobile orientation, the mobile header does
				// not scroll out of the way, we can just set the top value outright.
				this.leftPanel.css('top', constants.MOBILE_HEADER_HEIGHT + topMarginAdjustment)
			} else if (mobile.isMobileWidth()) {
				// If we're in the mobile width orientation, we need to dampen the start of the
				// top positioning of the left panel in order to move with it as it
				// scrolls off the top of the screen.
				if (scrollContainerTop <= constants.MOBILE_HEADER_HEIGHT) {
					// We haven't scrolled the mobile header out of the way yet,
					// let the panel continue scrolling up naturally
					let diff = constants.MOBILE_HEADER_HEIGHT - scrollContainerTop
					this.leftPanel.css('top', diff + topMarginAdjustment)
				} else {
					// The mobile header is scrolled out of the way, adjust the panel
					// top positioning.
					if (scrollContainerTop - constants.MOBILE_HEADER_HEIGHT > 0) {
						this.leftPanel.css('top', topMarginAdjustment)
					}
				}
			}
		}

		// Set the width of the left panel when it's floating (since it'll be
		// position: fixed at that time)
		this.leftPanel.css('width', this.$('.left-column').width())
		layoutManager.toggleTransitions(true)
	},

	// Get the height allotted to banners and their margin, if they're present
	_getBannersHeight: function() {
		let height = 0
		_.each(this.$('.banner:not(.is-not-displayed)'), banner => {
			height += this.$(banner).outerHeight() + constants.STANDARD_MARGIN
		})

		if (height > 0) {
			return height + constants.BORDER_WIDTH
		} else {
			return 0
		}
	},

	// If the left and right panels are stacked, return true, else return false
	panelsStacked: function() {
		if (this.options.isDialog) {
			return this.leftPanel.width() > this.scrollContainer.width()/2
		}

		let displaySize = layoutManager.getDisplaySize()
		return displaySize == 'display-small' || displaySize == 'display-medium'
	},

	_setMinDialogHeight: function() {
		let dialogBody = this.scrollContainer
		let tallestPanelHeight = Math.max(this.leftPanel.height(),
			this.rightPanel.height())
		let heightNeeded =  Math.max(tallestPanelHeight + constants.STANDARD_MARGIN*2,
			constants.FLOATING_PANEL_MIN_HEIGHT + constants.STANDARD_MARGIN*2)
		let heightAllowed = Number.parseInt(dialogBody.css('max-height')) // set in dialog.js:resize()
		dialogBody.css('min-height', Math.min(heightNeeded + this._getBannersHeight(), heightAllowed))
	},

	resize: function() {
		// NOTE: This needs to happen before calls to this.resizeLeftPanel &
		// this.adjustLeftPanelScroll
		if (this.options.isDialog) {
			this._setMinDialogHeight()
		}

		this.resizeLeftPanel()

		// When the form is resized, the scroll container might change, if that's the case,
		// we need to be able to update it's reference here for our calculations
		if (!this.scrollContainer.is(this.options.getScrollContainer())) {
			this.scrollContainer.off('scroll', this.adjustLeftPanelScroll)
			delete this.scrollContainer
			this.scrollContainer = this.options.getScrollContainer()
			this.scrollContainer.on('scroll', this.adjustLeftPanelScroll)
		}
	},

	remove: function () {
		// If we're in a dialog, remove the min-height for the dialog-body set in _setMinDialogHeight
		if (this.options.isDialog) {
			this.scrollContainer.css('min-height', '')
		}

		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

export default TwoColumnDetailsForm

TwoColumnDetailsForm.__filename__ = 'components/two-column-details-form.js'
